"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDaysWithAttention = void 0;
const luxon_1 = require("luxon");
const useDaysWithMissedPunch_1 = require("./useDaysWithMissedPunch");
const useDaysWithMissedPunchCorrection_1 = require("./useDaysWithMissedPunchCorrection");
const useDaysWithUpt_1 = require("./useDaysWithUpt");
const useDaysWithAttention = ({ punchCorrections, getPunchesResponse }) => {
    const daysWithMissedPunch = (0, useDaysWithMissedPunch_1.useDaysWithMissedPunch)({
        punchesTimeSegments: getPunchesResponse === null || getPunchesResponse === void 0 ? void 0 : getPunchesResponse.punchesTimeSegments
    });
    const daysWithMissedPunchCorrection = (0, useDaysWithMissedPunchCorrection_1.useDaysWithMissedPunchCorrection)({
        punchCorrections
    });
    const daysWithUpt = (0, useDaysWithUpt_1.useDaysWithUpt)({
        timeSegmentDailyAggregation: getPunchesResponse === null || getPunchesResponse === void 0 ? void 0 : getPunchesResponse.timeSegmentDailyAggregation
    });
    const dateStrings = new Set();
    for (const dateTime of daysWithMissedPunch) {
        dateStrings.add(dateTime.startOf('day').toISO());
    }
    for (const dateTime of daysWithMissedPunchCorrection) {
        dateStrings.add(dateTime.startOf('day').toISO());
    }
    for (const dateTime of daysWithUpt) {
        dateStrings.add(dateTime.startOf('day').toISO());
    }
    return Array.from(dateStrings).map((date) => luxon_1.DateTime.fromISO(date));
};
exports.useDaysWithAttention = useDaysWithAttention;
